<div class="ap-margin-bottom-3">{{ 'financial-obligations.personal-loan.amount' | apContent }}</div>
<ap-amount-input
    id="personalLoanAmount"
    [helpText]="'financial-obligations.personal-loan.amount.help-text' | apContent"
    [showSymbol]="true"
    [numberOfDecimals]="0"
    [formControl]="mainApplicantControl"
></ap-amount-input>

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()"></next-button>
}
